import { Steps } from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { CheckIcon } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';
import { useHistory, useLocation } from 'react-router-dom';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  edit?: boolean;
}

export default function AllocateCreate(props: IProps): JSX.Element {
  const { children, isLoading, edit } = props;
  const history = useHistory();
  const allocateData = useLocation().state as any;
  const setTilte =
    allocateData?.btn == 'Create' ? 'Tạo phân bổ' : 'Chỉnh sửa phân bổ';
  const step = useCategoryManagementStore((state) => state.step);
  const infoSteps = [
    {
      title: 'Khai báo vốn CN',
      icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
      className: 'step-first',
    },
    {
      title: 'Danh sách phân bổ',
      icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
      className: 'step-last',
    },
  ];
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo phân bổ');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/">Thông tin đơn vị</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/branchs-capital-detail">
              Phân bổ vốn tồn {allocateData?.allocationDetailData?.capital_year}
            </a>
          </p>
        ),
      },
      { title: <a href="">{setTilte}</a> },
    ]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Steps
        current={step}
        className="add-Allocate-step mb-7"
        items={infoSteps}
      />
      <div className="p-1">{children}</div>
    </MainLayout>
  );
}
